import React from 'react'

import Svg from 'Svg'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import css from './SocialIconButton.css'

const BUTTON_CLASSES = {
  email: css['button-email'],
  facebook: css['button-facebook'],
  'facebook-messenger': css['button-facebook-messenger'],
  link: css['button-link'],
}

const SocialIconButton = ({ type, onClick, text }) => {
  const socialButtonClasses = classnames(BUTTON_CLASSES[type])

  const svgClasses = classnames(css.icon)

  return (
    <div
      className={socialButtonClasses}
      onClick={onClick}
      onKeyPress={onClick}
      role="button"
      tabIndex="0"
      aria-label={text}
    >
      <Svg fileName={`icon-${type}`} className={svgClasses} hidden />
    </div>
  )
}

const propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  text: PropTypes.string,
}

const defaultProps = {
  onClick: () => {},
  text: '',
}

SocialIconButton.propTypes = propTypes
SocialIconButton.defaultProps = defaultProps

export { SocialIconButton }
